/**
 * EN content for the "Èze – La Turbie" private excursion.
 *
 * Role: English translation of slugs/eze-la-turbie.ts, typed `ExcursionPage`
 * for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place names).
 */
import type { ExcursionPage } from "../slug-excursions";
import laturbie from "@/assets/images/excursions/destinations/laturbie.jpeg";

const page: ExcursionPage = {
  slug: "eze-la-turbie",
  hero: {
    title: "Èze – La Turbie Excursion",
    subtitle:
      "Hilltop villages, panoramic views and the scent of the Mediterranean.",
    ctaPrimaryHref: "/en/reservation",
    ctaPrimaryLabel: "Book now",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Get a quote",
    image: laturbie,
  },
  highlights: {
    title: "Highlights",
    items: [
      { text: "Èze: a hilltop village and exotic garden" },
      { text: "La Turbie: the Trophy of the Alps and sea views" },
      { text: "Panoramic roads of the Grande Corniche" },
      { text: "Photo stops overlooking the Mediterranean" },
    ],
  },
  itinerary: {
    title: "Sample itinerary",
    steps: [
      {
        title: "Èze",
        description: "Climb to the garden, lanes, perfumery (optional)",
      },
      {
        title: "La Turbie",
        description: "Village centre, Trophy of Augustus (exterior)",
      },
    ],
  },
  practical: {
    title: "Practical information",
    items: [
      { label: "Duration", value: "4 to 6 hours" },
      { label: "Departure", value: "Cannes" },
      { label: "Terrain", value: "A few slopes / steps along the way" },
      {
        label: "Garden tickets",
        value: "Entry to the exotic garden not included",
      },
    ],
  },
  seo: {
    title: "Èze – La Turbie Excursion | Private Chauffeur Day Trip",
    description:
      "Private excursion from Cannes to Èze and La Turbie: hilltop villages, exotic garden, the Trophy of the Alps and Grande Corniche panoramic views.",
    canonical: "/en/excursions/eze-la-turbie",
  },
};

export default page;
